import axios from 'axios';
import {BASE_URL} from '../ApiService/ApiConfig'


const URL_BASE_MONITOREO = BASE_URL;
const CONFIG_CAB_ROLES_CODE = 'ROL-0000-0000';
// Los permisos viven bajo el tipo PRM-0000 (distintas cabeceras: CRUD, bloques por pantalla, etc.).
// Consultamos a nivel de tipo para agrupar todas las cabeceras.
const CONFIG_TIPO_PERMISOS_CODE = 'PRM-0000';

const obtenerConfig = () => {
    const token = localStorage.getItem('jwt').replaceAll('"', '');

    return {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            Authorization: 'Bearer ' + token
        }
    };
};

export const getPantallasByUsuarioId = async (usuarioId) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/rolPantalla/pantallas/${usuarioId}`, obtenerConfig());
        //console.log('hh02:', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: En API de Pantallas: ${usuarioId}`, error);
        if (error.response?.status === 404) {
            throw new Error('Usuario no encontrado');
        } else if (error.response?.status === 403) {
            throw new Error('No tiene permisos para la pantalla');
        } else if (error.response?.status >= 500) {
            throw new Error('Error del servidor... intente mas tarde');
        } else if (error.code === 'NETWORK_ERROR') {
            throw new Error('Error de conexion.');
        } else {
            throw new Error('Error inesperado');
        }
    }
};

export const getRolesOpem = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/simpleConfiguracionDet/configCabCode/${CONFIG_CAB_ROLES_CODE}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('ERROR: Error al obtener los roles');
        throw new Error('No se ha podido recuperar los Roles.');
    }
};

export const getUsuariosByRol = async (rolCode) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/usuarioRol/rol/${rolCode}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('Error: No se puede obetner los Usuarios');
        throw new Error('No se pueden recuperar Usuarios de rol: ', rolCode);
    }
};

export const getUsuariosActivos = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/simpleUser/activos`, obtenerConfig());
        return response.data;
    } catch (err) {
        console.error('Error: NO se pueden obtener los Usuarios');
        throw new Error('Error al recuperar Usuarios');
    }
};

export const creaRolesXUser = async (objPost) => {
    //console.log('MXMX0=', objPost)
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/simpleUsuarioRol/crearUsuarios`, objPost, obtenerConfig());
        return response.data;
    } catch (err) {
        console.error('Error: No se ha podido guardar');
        throw new Error('ERROR al guardar Usuarios');
    }
};

export const borraRolesXUser = async (objPost) => {
    //console.log('MXMX0=', objPost)
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/simpleUsuarioRol/borrarUsuarios`, objPost, obtenerConfig());
        return response.data;
    } catch (err) {
        console.err('Error: Error al borrar Usuarios');
        throw new Error('ERROR: al borrar usuarios');
    }
};

export const getPermisosPan = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/simpleConfiguracionDet/configTipoCode/${CONFIG_TIPO_PERMISOS_CODE}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('ERROR: Error al obtener definicion de permisos');
        throw new Error('No se ha podido recuperar permisos');
    }
};

export const getPantallasByRol = async (rolId) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/rolPantallaPermiso/rol/${rolId}`, obtenerConfig());
        return response.data;
    } catch (err) {
        console.error('ERROR: Error al obtener Pantallas del Rol');
        throw new Error('No se ha podido obtener las Pantallas');
    }
};

export const getPermisosByRol = async (rolId) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/rolPantallaPermiso/byRol/${rolId}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('ERROR: Error al obtener Pantallas del Rol');
        throw new Error('No se ha podido obtener las Pantallas');
    }
};

export const guardarPermisos = async (rolId, objPost) => {
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/rolPantallaPermiso/grabar/${rolId}`, objPost, obtenerConfig());
        //console.log('WW0=', response.data)
    } catch (error) {
        console.error('ERROR: Error al guardar los Permisos');
        throw new Error('No se ha podido guardar los Permisos');
    }
};

export const borrarPantallaRol = async (objPost) => {
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/rolPantallaPermiso/borrar`, objPost, obtenerConfig());
        //console.log('WW0=', response.data)
    } catch (error) {
        console.error('ERROR: Error al Eliminar Pantalla');
        throw new Error('No se ha podido Eliminar la Pantalla');
    }
};

export const getPantallasNoRol = async (rolId) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/rolPantalla/pantallasNoRol/${rolId}`, obtenerConfig());
        //console.log('WW0=', response.data)
        return response.data;
    } catch (error) {
        console.error('ERROR: Error al obtener Pantallas que no son del Rol');
        throw new Error('No se puede obtener Pantallas del Rol');
    }
};

export const guardaPantallaRol = async (objPost) => {
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/rolPantallaPermiso/adicionPant`, objPost, obtenerConfig());
        //console.log('WW0=', response.data)
        return response.data;
    } catch (error) {
        console.error('ERROR: Error al Guardar Datos');
        throw new Error('No se han podido guardar los datos');
    }
};

/* para Configuraciones */
export const getAllConfigTipo = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/simpleConfiguracionTipo`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('ERROR: Error al Recuperar Datos');
        throw new Error('No se han podido Recuperar los datos');
    }
};

export const getConfigCabByTipo = async (configTipoId) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/simpleConfiguracionCab/${configTipoId}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('ERROR: Error al Recuperar Datos');
        throw new Error('No se han podido Recuperar los datos');
    }
};

export const getConfigDetByCab = async (configCabId) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/simpleConfiguracionDet/configCabId/${configCabId}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('ERROR: Error al Recuperar Datos');
        throw new Error('No se han podido Recuperar los datos');
    }
}

export const getCodigoTipo = async (inicial) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/simpleConfiguracionTipo/nuevoCodigo/${inicial}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('ERROR: Error al Recuperar Nuevo Codigo');
        throw new Error('No se han podido Recuperar nuevo Tipo');
    }
}

export const creaNuevoTipo = async (objPost) => {
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/simpleConfiguracionTipo`, objPost, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('ERROR: Error al crear Tipo');
        throw new Error('No se crear nuevo Tipo');
    }
}

export const getCodigoCab = async (tipoId, codIni) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/simpleConfiguracionCab/nuevoCodigo/${tipoId}/${codIni}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('ERROR: Error obtener nuevo Codigo');
        throw new Error('No se crear nuevo codigo Cab');
    }
}

export const creaNuevoCab = async (objPost) => {
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/simpleConfiguracionCab`, objPost, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('ERROR: Error al crear Cabecera');
        throw new Error('No se crear nuevo Cabecera');
    }
}

export const getCodigoDet = async (confCabId, codInicial) =>{
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/simpleConfiguracionDet/nuevoCodigo/${confCabId}/${codInicial}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('ERROR: Error obtener nuevo Codigo Det');
        throw new Error('No se crear nuevo codigo Det');
    }
}

export const creaNuevoDet = async (objPost) => {
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/simpleConfiguracionDet`, objPost, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('ERROR: Error al crear Detalle');
        throw new Error('No se crear nuevo Detalle');
    }
}

export const modificaDet = async (objPost) => {
    try {
        const response = await axios.put(`${URL_BASE_MONITOREO}/simpleConfiguracionDet`, objPost, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('ERROR: Error al crear Detalle');
        throw new Error('No se crear nuevo Detalle');
    }
}


export const eliminaDet = async (detalleId) => {
    try {
        // Asumiendo que tu API sigue el estándar REST para el controlador 'simpleConfiguracionDet'
        const response = await axios.delete(`${URL_BASE_MONITOREO}/simpleConfiguracionDet/${detalleId}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('ERROR: Error al eliminar Detalle');
        throw new Error('No se pudo eliminar el Detalle');
    }
};